import { defineStore } from 'pinia'
import { ref } from '@nuxtjs/composition-api'
import { fetchWiFiData } from './../index'
import { IWifi } from './types'

export const useWiFiModel = defineStore('wifi', () => {
  const data = ref<IWifi>({
    active: false,
    id: 0,
    shop_id: 0,
    network: '',
    password: ''
  })
  const modal = ref<boolean>(false)

  const fetchData = async (id: number) => {
    const res = await fetchWiFiData(id)
    data.value = res
  }

  return {
    data,
    modal,
    fetchData
  }
})
